import { emit as zapierEmit } from "@zapier/events-toolkit-browser";

export async function emit(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventData: Record<string, any>,
  eventType: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<[boolean, Record<string, any> | undefined]> {
  /**
   * TODO: https://zapierorg.atlassian.net/browse/INTRFCS-4470
   */
  return await zapierEmit(eventData, eventType);
}
